import { NgModule } from '@angular/core';

import { RouterService } from './router.service';
import { RouterModalService } from './hooks/router-modal.service';
import { RouterScrollService } from './hooks/router-scroll.service';
import { RouterSecurityService } from './hooks/router-security.service';

@NgModule({
  providers: [
    RouterService,
    RouterModalService,
    RouterScrollService,
    RouterSecurityService
  ]
})
export class RouterModule {
}
